export const INPUT_TYPE_OPTIONS = [
    { id: 'fi', text: 'Krótka odpowiedź', icon: 'fas fa-font' },
    { id: 'fj', text: 'Krótka odpowiedź z podpowiedzią', icon: 'far fa-lightbulb' },
    { id: 'fl', text: 'Długa odpowiedź', icon: 'fas fa-align-left' },
    { id: 'fr', text: 'Jednokrotny wybór', icon: 'far fa-dot-circle' },
    { id: 'fs', text: 'Menu', icon: 'fas fa-list' },
    { id: 'fc', text: 'Potwierdzenie', icon: 'far fa-check-square' },
    { id: 'fh', text: 'Godzina', icon: 'far fa-clock' },
    { id: 'fd', text: 'Data', icon: 'far fa-calendar' },
    { id: 'fa', text: 'Paczkomat Inpost', icon: 'fas fa-archive' },
];

export const VALIDATION_OPTIONS = [
    { id: '', text: 'Bez sprawdzania odpowiedzi' },
    { id: 'phone', text: 'Numer telefonu' },
    { id: 'email', text: 'Adres email' },
    { id: 'number', text: 'Tylko liczba' },
    { id: 'max_length_10', text: 'Max 10 znaków' },
    { id: 'max_length_40', text: 'Max 40 znaków' },
    { id: 'max_length_100', text: 'Max 100 znaków' },
];

let keySeq = 0;

export function nextInputKey() {
    keySeq += 1;
    return `input-${Date.now()}-${keySeq}`;
}

export function parseDescriptionOptions(desc) {
    if (Array.isArray(desc)) {
        const list = desc.map((item) => (item == null ? '' : String(item)));
        return list.length ? list : ['', ''];
    }
    if (!desc || typeof desc !== 'string') {
        return ['', ''];
    }
    const trimmed = desc.replace(/^\|/, '').replace(/\|$/, '');
    if (!trimmed) {
        return ['', ''];
    }
    const parts = trimmed.split('||');
    return parts.length ? parts : ['', ''];
}

export function createEmptyInput(classificationIds = []) {
    return {
        _key: nextInputKey(),
        id: 0,
        position: 0,
        fType: 'fi',
        fNamePl: '',
        fRequired: false,
        fValidation: '',
        options: ['', ''],
        hint: '',
        confirmation: '',
        classificationIds: [...classificationIds],
    };
}

export function mapApiInputToForm(input, allClassificationIds = []) {
    const fType = input.fType || input.f_type || 'fi';
    const fDescriptionPl = input.fDescriptionPl != null ? input.fDescriptionPl : input.f_description_pl;
    const raw = Array.isArray(input.classification) ? input.classification : [];
    const classificationIds = raw.length
        ? raw.map((id) => Number(id))
        : [...allClassificationIds];

    let options = ['', ''];
    let hint = '';
    let confirmation = '';

    if (fType === 'fr' || fType === 'fs') {
        options = parseDescriptionOptions(fDescriptionPl);
    } else if (fType === 'fj') {
        hint = fDescriptionPl == null ? '' : String(fDescriptionPl);
    } else if (fType === 'fc') {
        confirmation = fDescriptionPl == null ? '' : String(fDescriptionPl);
    }

    return {
        _key: nextInputKey(),
        id: input.id || 0,
        position: input.position != null ? input.position : 0,
        fType,
        fNamePl: input.fNamePl || input.f_name_pl || '',
        fRequired: Boolean(input.fRequired != null ? input.fRequired : input.f_required),
        fValidation: input.fValidation != null ? input.fValidation : input.f_validation || '',
        options,
        hint,
        confirmation,
        classificationIds,
    };
}

export function mapFormInputToApi(input, position) {
    const { fType } = input;
    let fDescriptionPl = '';

    if (fType === 'fr' || fType === 'fs') {
        fDescriptionPl = (input.options || []).map((item) => String(item || '').trim()).filter(Boolean);
    } else if (fType === 'fj') {
        fDescriptionPl = input.hint || '';
    } else if (fType === 'fc') {
        fDescriptionPl = input.confirmation || '';
    }

    return {
        id: input.id || 0,
        position,
        fType,
        fNamePl: fType === 'fc' ? '' : input.fNamePl || '',
        fRequired: Boolean(input.fRequired),
        fValidation: fType === 'fi' || fType === 'fl' ? input.fValidation || '' : '',
        fDescriptionPl,
        classification: input.classificationIds || [],
    };
}
